import React, { useEffect, useState, Fragment, useRef, useCallback } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { ReactComponent as BackArrow } from "./../../back-arrow.svg"
import { ReactComponent as MoreElipsis } from "./../../more-elipsis.svg"
import { ReactComponent as FontIcon } from "./../../fonts.svg"
import { ReactComponent as DropdownArrow } from "./../../assets/dropdown-arrow.svg"
import { ReactComponent as DownloadIcon } from "../../../../../assets/svg/static-assets/download.svg"
import { ReactComponent as TickIcon } from "../../../../../assets/svg/static-assets/tick.svg"
import { ReactComponent as SearchIcon } from "./../../assets/search-icon.svg"
import { ReactComponent as LinkIcon } from "./../../assets/link-icon.svg"
// import { ReactComponent as DownloadIcon } from "./../../assets/download-icon.svg"
import { useHistory, useParams } from 'react-router-dom';
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { BsTrash } from "react-icons/bs";

import "./style.scss";
import { loadEnv, useToast } from '../../../../../helpers/commonFunction';
import { Http } from '../../../../../helpers/axois';
import { useDispatch, useSelector } from 'react-redux';
import { AppState, RootState } from '../../../../../stateManager/store';
import { createNewFontAsset, deleteFontAssetById, enlistGoogleFont, fetchAllStaticAssetsByFiletype } from '../../../../../stateManager/store/static-assets/action';
import classNames from 'classnames';

import WebFont from 'webfontloader';
import axios from "axios";
import ReactPaginate from 'react-paginate';
import { FontType } from "../../../../../stateManager/store/static-assets/types";
import fontkit from "@pdf-lib/fontkit";
import { motion, AnimatePresence } from "framer-motion";
import { useDropzone } from "react-dropzone";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { ReactComponent as UploadCustomFont } from "./../../assets/upload-custom-font.svg";
import { ReactComponent as FontSuccess } from "./../../assets/font-success.svg";
import { ReactComponent as FontError } from "./../../assets/font-error.svg";
import { ReactComponent as FontDelete } from "./../../assets/font-delete.svg";
import { handleCustomFontFace } from "../../../forms/formBuilder/PropertiesPanel/layout-components/helpers/handleCustomFontFace"

class WebFonts {
    private _fontsList: FontType[] = [];
    public set fontsList(fontsList: FontType[]) {
        this._fontsList = fontsList
    }

    public get fontsList(): FontType[] {
        return this._fontsList
    }
}

const loadRequiredGoogleFonts = (googleFontsList: { [key: string]: any }) => {
    const fontNames: string[] = googleFontsList && Object.values(googleFontsList)?.map((font: any) => font?.filename);
    if (fontNames?.length > 0) {
        WebFont.load({
            google: {
                families: fontNames
            },
        });
    }
}

const webFonts = new WebFonts();

const ADD_NEW_BTN = "+ New";
const COPY_URL_BTN = "Copy Url";
const PAGE_TITLE = "Fonts"
const PAGE_SUBTITLE = "View, upload or remove a font from assets"
const itemsPerPage = 6; // Number of fonts per page
const DEFAULT_FONT_TEXT = "The quick brown fox jumps over the lazy frog";

export const FontsFolder = () => {
    const [envLoaded, setEnvLoaded] = useState<boolean>(false);
    const [shownFontsList, setShownFontsList] = useState<any[]>([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [sampleText, setSampleText] = useState(DEFAULT_FONT_TEXT)
    const [editSampleText, setEditSampleText] = useState(false)
    const history = useHistory();
    const dispatch = useDispatch();
    const { SuccessToast, ErrorToast } = useToast();
    const params: { appId: string } = useParams();
    const fontFiles = useSelector((state: RootState) => state.staticAssets.fonts)
    const googleFontsList = useSelector(
        (state: RootState) => categorizeFonts(state.staticAssets.fonts)
    );
    const orgId = useSelector((state: AppState) => state.org.selectedOrg.id);
    const currentBranch: { branchId: string } = useSelector((state: any) => {
        const selectedAppId = state.apps.selectedApp && state.apps.selectedApp.id
        return (state.apps.appBranch && state.apps.appBranch[selectedAppId]) || {}
    }, (left: any, right: any) => left.branchId === right.branchId);
    const appversion: { currentVersion: boolean; versionId: string } = useSelector((state: AppState) => state.apps.appVersion[params.appId]);
    const [selectedFontId, setSelectedFontId] = useState("");
    const [dropdownIsOpen, setDropdownIsOpen] = useState<boolean>(false)
    const options = [
        { id: 1, name: 'Google Fonts' },
        { id: 2, name: 'Custom Fonts' },
    ]
    const [selected, setSelected] = useState(options[0])
    const [searchValue, setSearchValue] = useState("")
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [webfontsUrl, setWebfontsUrl] = useState<string>("");
    const [customUploadVisible, setCustomUploadVisible] = useState<boolean>(false)
    const [selectedCategory, setSelectedCategory] = useState<string>("")

    const { selectedOrg } = useSelector((state: AppState) => state.org)
    const loggedInUserId = useSelector((state: any) => {
        return state.user.data.user.id
    })
  const orgPermissions: any = useSelector((state: AppState) => {
    return state.org.orgPermissions
}, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
    let googleFontsApiKey;
    useEffect(() => {
        fetchFontFiles();
        const fetchConfig = async () => {
            const env: any = await loadEnv();
            googleFontsApiKey = env.GOOGLE_FONTS_API_KEY;
            setWebfontsUrl(`https://www.googleapis.com/webfonts/v1/webfonts?key=${'AIzaSyD1Ycpj7WNBAACncF2vOaYDn7xtnHc5T7Q'}`); // 2GB
            setEnvLoaded(true);
        }
        fetchConfig();
        let initialFontCollection = googleFontsList.customFonts && Object.keys(googleFontsList.customFonts)[0]
        setSelectedCategory(initialFontCollection)
        window.addEventListener("click", () => setEditSampleText(false));

        return () => window.addEventListener("click", () => setEditSampleText(false))
    }, []);
    const handlePageClick = (selectedItem: { selected: number }) => {
        setCurrentPage(selectedItem.selected);
    };

    const pageCount = Math.ceil(shownFontsList?.length / itemsPerPage);
    const offset = currentPage * itemsPerPage;

    const displayedFonts = shownFontsList?.slice(offset, offset + itemsPerPage);

    const handleBackArrowClick = () => {
        history.goBack();
    }

    const fetchFontFiles = () => {
        const payload = {
            "appId": params.appId,
            "filetype": "font",
            orgId
        }
        dispatch(fetchAllStaticAssetsByFiletype(payload))
    }

    const handleFontUpload = async (e: any) => {
            if (e.fileData) {
                const file: File = e.fileData;
                const { type, name } = file;
                const [fileName, ext] = name.split(".")
                const updated_filename = `${e.familyName+"-"+e.subfamilyName}.${ext}`;
                // todo: request for presigned url
                const payload = {
                    filetype: type,
                    filename: updated_filename.replace(/\s+/g, '-'),
                    orgId,
                    appId: params.appId
                }
                const resp: any = await Http.post("/static-asset/get-upload-url", payload, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }).toPromise()
                if (resp.ok) {
                    // upload to presigned url
                    await Http.put(resp.url, file, {
                        headers: {
                            "Content-Type": type
                        }
                    }).toPromise();
                    // update data with asset
                    const data: any = await Http.post("/static-asset/create", {
                        appId: params.appId,
                        filename: updated_filename,
                        filetype: "font",
                        url: resp.filePath,
                        orgId
                    }).toPromise()
                    let fontDetails = data.asset;
                    const fontFaceDetails = handleCustomFontFace(fontDetails.filename);
                    let fontProperties:any = {}
                    if(fontFaceDetails?.fontWeight){
                        fontProperties["weight"] = fontFaceDetails?.fontWeight.toString();
                    }
                    if(fontFaceDetails?.fontStyle){
                        fontProperties["style"] = fontFaceDetails?.fontStyle;
                    }
                    const font = new FontFace(
                        fontFaceDetails.fontName, 
                        `url(${fontDetails.url}) format(${fontFaceDetails.format})`, fontProperties
                        );
                    font.load().then(() => {
                        document.fonts.add(font);
                    }).catch(error => {
                        console.error('Failed to load the font:', error);
                    });
                    data.asset.filename = fontFaceDetails.baseName;
                    dispatch(createNewFontAsset(data))
                    SuccessToast("Font uploaded successfully")
                }
            }
    }

    const handleFontFileUrlCopy = () => {
        if (!selectedFontId) {
            ErrorToast("Select a file");
        } else {
            const url = fontFiles[selectedFontId].url
            navigator.clipboard.writeText(url);
            SuccessToast("URL copied to clipboard")
        }
    }

    // Close dropdown if clicked on outside of element
    function handleClickOutside(event: Event) {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
            setDropdownIsOpen(false);
        }
    }

    useEffect(() => {
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);

    useEffect(() => {
        // fetchFontFiles();
        const fetchGoogleFonts = async () => {
            try {
                const res = await axios.get(webfontsUrl)
                if (res.data) {
                    webFonts.fontsList = res.data.items;
                }
            } catch (error) {
                ErrorToast("Error loading google fonts")
            }
        }
        fetchGoogleFonts();
    }, [webfontsUrl])

    const validateIsGoogleFont = (fontUrl: string) => {
        // Check if the URL includes "fonts.googleapis.com" (Google Fonts domain)
        if (fontUrl.includes("fonts.googleapis.com")) {
          return true;
        } else {
          return false;
        }
    };

    const handleFontsSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(event.target.value);
    }

    const handleFontsSearchFocus = () => {
        setDropdownIsOpen(true);
    }

    // debouncing searchValue input
    useEffect(() => {
        if (selected.id === 1) {
            const re = new RegExp(searchValue, 'i');

            let debounceTimeout!: NodeJS.Timeout;
            if (debounceTimeout) {
                clearTimeout(debounceTimeout)
            }
            debounceTimeout = setTimeout(() => {
                const filtered = webFonts?.fontsList?.filter(
                    (entry: FontType) => {
                        const value: string = entry.family;
                        return (searchValue !== "" && value.match(re))
                    }
                ).map(font => {
                    return {
                        filename: font.family
                    }
                });
                setShownFontsList(filtered)
            }, 300); // Adjust the debounce delay as needed (e.g., 300 milliseconds)

            return () => {
                clearTimeout(debounceTimeout); // Clear the timeout if the input changes
            };
        } else {
            const filteredFont = Object.keys(googleFontsList.customFonts)
            .filter(fontFamily => !searchValue || fontFamily.toLowerCase().includes(searchValue.toLowerCase()))
            .map((fontFamily) => { return fontFamily })
            if ( filteredFont?.length > 0 ) {
                setSelectedCategory(filteredFont[0])
            } else {

            }
        }
    }, [searchValue]);

    useEffect(() => {
        loadRequiredGoogleFonts(googleFontsList.googleFonts);
    }, [googleFontsList])

    const constructFontUrl = (fontname: string): string => {
        const font: FontType | undefined = webFonts.fontsList.find(font => font.family === fontname);
        if (font) {
            let addedText: string = "";
            let boldItalicText: string = "";
            let boldText: string = "";
            // Create a string like below
            // @import url('https://fonts.googleapis.com/css2?family=Slabo+27px')
            if (font.variants.length === 1 && font.variants.includes("regular")) {
                addedText = font.family.split(" ").join("+");
            }
            // Create a string like below in case both italic and normal font styles are included in the variants
            // @import url('https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900')
            else if (font.variants.includes("regular") && font.variants.includes("italic")) {
                boldItalicText = font.variants.reduce((accumulator: string, currentValue: string, index: number) => {
                    const isLast = index === font.variants.length - 1;
                    if (currentValue === "regular") {
                        return accumulator + "0,400" + (isLast ? '' : ';');
                    }
                    else if (/^[1-9]00$/.test(currentValue) === true) {
                        return accumulator + "0," + currentValue + (isLast ? '' : ';')
                    }
                    else if (currentValue === "italic") {
                        return accumulator + "1,400" + (isLast ? '' : ';')
                    }
                    else {
                        const match = currentValue.match(/^[1-9]00italic$/);
                        let extractedNumber;
                        if (match) {
                            extractedNumber = match[0].replace(/italic/g, '');
                        }
                        return accumulator + "1," + extractedNumber + (isLast ? '' : ';')
                    }
                }, "")
                addedText = font.family.split(" ").join("+") + ":ital,wght@" + boldItalicText;
            }
            // Create a string like below in case no italic styles are present in the variants
            // @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@100;200;300;400')
            else if (font.variants.length > 1 && font.variants.includes("regular") && !font.variants.includes("italic")) {
                boldText = font.variants.reduce((accumulator: string, currentValue: string, index: number) => {
                    const isLast = index === font.variants.length - 1;
                    if (currentValue === "regular") {
                        return accumulator + "400" + (isLast ? '' : ';');
                    }
                    else {
                        return accumulator + currentValue + (isLast ? '' : ';')
                    }
                }, "")
                addedText = font.family.split(" ").join("+") + ":wght@" + boldText;
            }

            return addedText;
        }
        return ""
    }

    const handleFontLinkClick = (fontUrl: string) => {
        // copy the linkText to clipboard
        navigator.clipboard.writeText(fontUrl);
        // display success toast
        SuccessToast("Font import code copied to clipboard")
    }

    const handleFontAddClick = (fontname: string) => {
        if((!orgPermissions?.includes("staticAsset.Create") || !orgPermissions.includes('app.View'))&& loggedInUserId!=selectedOrg?.owner ){
            ErrorToast("Not Authorized: Please request owner of this organization to provide access")
           return
          }
        const addedText = constructFontUrl(fontname)
        const fontUrl = "https://fonts.googleapis.com/css2?family=" + addedText
        dispatch(enlistGoogleFont(orgId, params.appId, fontname, fontUrl));
    }

    const handleFontDelete = async (font: any) => {
        const resp: any = await dispatch(deleteFontAssetById(orgId, params.appId, font.id, font.filename));
        if (resp.ok) {
            SuccessToast(`${font.filename} deleted successfully`)
        } else {
            ErrorToast("Failed to delete the font")
        }
    }

    const customFilteredFonts = Object.keys(googleFontsList.customFonts)
        .filter(fontFamily => 
            !searchValue || fontFamily.toLowerCase().includes(searchValue.toLowerCase())
        )
        .map((fontFamily, index) => {
            return fontFamily
        })
    return (
        <div className="fonts-wrapper">
            <div className="fonts-header__container">
                <div className="fonts-header__content-wrapper">
                    <div className="header">
                        <BackArrow className='backarrow' onClick={handleBackArrowClick} />
                        <div className="header-content">
                            <div className="header-content--title">{PAGE_TITLE}</div>
                            <div className="header-content--subtitle">{PAGE_SUBTITLE}</div>
                        </div>
                    </div>
                    <div className="submit-wrapper" ref={wrapperRef}>
                        <div className='fonts-search-input'>
                            <span className='fonts-search-input__search-icon'>
                                <SearchIcon />
                            </span>
                            <input id="fontsSearchInput" onFocus={handleFontsSearchFocus} onChange={handleFontsSearchChange} value={searchValue} type="text" />
                        </div>
                        <FontsSearchList
                            displayedFonts={displayedFonts}
                            dropdownIsOpen={dropdownIsOpen}
                            handlePageClick={handlePageClick}
                            shownFontsList={shownFontsList}
                            handleFontAddClick={handleFontAddClick}
                        />
                        <Listbox value={selected} onChange={setSelected}>
                            <div className="fonts-list-box relative">
                                <Listbox.Button className="fonts-list-box__button relative w-full cursor-default rounded-lg bg-white text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm">
                                    <span className="block truncate">{selected.name}</span>
                                    <span>
                                        <DropdownArrow />
                                    </span>
                                </Listbox.Button>
                                <Transition
                                    as={Fragment}
                                    leave="transition ease-in duration-100"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                >
                                    <Listbox.Options className="fonts-list-box__list absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
                                        {options.map((option, optionIdx) => (
                                            <Listbox.Option
                                                key={option.id}
                                                className={({ active }) =>
                                                    `fonts-list-box__list-item relative cursor-default select-none ${active ? 'bg-amber-100 text-amber-900' : 'text-gray-900'
                                                    }`
                                                }
                                                value={option}
                                            >
                                                {({ selected }) => (
                                                    <span
                                                        className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                            }`}
                                                    >
                                                        {option.name}
                                                    </span>
                                                )}
                                            </Listbox.Option>
                                        ))}
                                    </Listbox.Options>
                                </Transition>
                                
                            </div>
                        </Listbox>
                        <CustomFontUploadModal isVisible= {customUploadVisible} handleCustomVisible={(value: boolean) => setCustomUploadVisible(value)} handleFontUpload={handleFontUpload}/>
                    </div>
                </div>
            </div>
            <hr />
            <div className="fonts-body__container" style={{ padding: selected.id === 2 ? "0px" : "20px" }}>
                <AnimatePresence>
                    <div className='fonts-body__fonts-list' style={{height: "100%"}}>
                        {selected.id === 1 && ( //list google fonts
                            <motion.div
                                key={selected.id}
                                initial={{ y: 10, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                exit={{ y: -10, opacity: 0 }}
                                transition={{ duration: 0.2 }}
                            >
                            <table className='fonts-body__fonts-list-table fonts-body__fonts-list-table--selected'>
                                <thead>
                                    <tr>
                                        <th className='fonts-body__fonts-list-table__name-column'>
                                            Name
                                        </th>
                                        <th className='fonts-body__fonts-list-table__action-column'>
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selected.id === 1 &&
                                        Object.values(googleFontsList?.googleFonts)?.map(
                                            (font: any, index: number) => (
                                                <tr key={index}>
                                                    <td>
                                                        <span>{font.filename}</span>
                                                        <SampleText
                                                            processFrom="googleFonts"
                                                            editSampleText={
                                                                editSampleText
                                                            }
                                                            fontFamily={
                                                                font.filename
                                                            }
                                                            fontUrl={font.url}
                                                            sampleText={sampleText}
                                                            setEditSampleText={
                                                                setEditSampleText
                                                            }
                                                        />
                                                    </td>
                                                    <td>
                                                        <button
                                                            className="focus:outline-none outline-none"
                                                            title='Copy Font Url'
                                                            onClick={() =>
                                                                handleFontLinkClick(
                                                                    font.url
                                                                )
                                                            }
                                                        >
                                                            <LinkIcon />
                                                        </button>
                                                        <button
                                                            className="focus:outline-none outline-none"
                                                            title='Delete'
                                                            onClick={() =>
                                                                handleFontDelete(
                                                                    font
                                                                )
                                                            }
                                                        >
                                                            <BsTrash size={16} />
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                </tbody>
                            </table>
                            </motion.div>
                        )}
                        {selected.id === 2 && ( //list custom fonts
                            <motion.div
                                key={selected.id}
                                initial={{ y: 10, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                exit={{ y: -10, opacity: 0 }}
                                transition={{ duration: 0.2 }} 
                                className="css-wrapper"
                                style={{height:"100%"}}
                            >
                                <div className="css-body__container" style={{height:"100%"}}>
                                    <div
                                        className="css-sidebar"
                                        style={{ overflow: "hidden", height:"100%" }}
                                    >
                                        <button type="button" className="add-new" onClick={()=>setCustomUploadVisible(true)} style={{marginBottom: "9px"}}>
                                            Upload Font
                                        </button>
                                        <div style={{ overflowY: "auto", overflowX: "hidden", height: "calc(100% - 40px)", position: "relative" }}>
                                            <ul style={{ listStyleType: "none", padding: 0, position: "relative" }}>
                                                {selectedCategory && (
                                                    <motion.div
                                                        layoutId="highlight"
                                                        initial={false}
                                                        animate={{
                                                        y: customFilteredFonts.indexOf(selectedCategory) * 36,
                                                        }}
                                                        transition={{
                                                        type: "spring",
                                                        stiffness: 500,
                                                        damping: 24,
                                                        }}
                                                        style={{
                                                        position: "absolute",
                                                        width: "100%",
                                                        height: "36px",
                                                        borderRadius: "6px",
                                                        backgroundColor: "#EDF5FF",
                                                        zIndex: 0,
                                                        }}
                                                    />
                                                )}
                                                {customFilteredFonts.map((fontFamily) => {
                                                    const isSelected = fontFamily === selectedCategory;
                                                    return (
                                                        <motion.li
                                                            key={fontFamily}
                                                            className={isSelected ? "custom-font-family custom-font-family-selected" : "custom-font-family"}
                                                            onClick={() => setSelectedCategory(fontFamily)}
                                                            whileTap={{ scale: 1.03 }}
                                                            style={{
                                                                padding: "8px",
                                                                borderRadius: "5px",
                                                                cursor: "pointer",
                                                                position: "relative",
                                                                zIndex: 1,
                                                                backgroundColor: isSelected ? "transparent" : "transparent",
                                                            }}>
                                                            {fontFamily}
                                                        </motion.li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                    <div
                                        className="css-main--editor"
                                        style={{ padding: "8px 16px", overflowY: "auto" }}
                                    >
                                        <table className="fonts-body__fonts-list-table fonts-body__fonts-list-table--selected">
                                            <thead>
                                                <tr>
                                                    <th className="fonts-body__fonts-list-table__name-column">
                                                        Name
                                                    </th>
                                                    <th className="fonts-body__fonts-list-table__action-column">
                                                        Action
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    customFilteredFonts.length > 0 && googleFontsList?.customFonts[selectedCategory] && (
                                                        Object.values(googleFontsList?.customFonts[selectedCategory])?.map(
                                                            (font: any, index: number) => (
                                                                <motion.tr 
                                                                    key={selectedCategory + index}
                                                                    initial={{ y: 5, opacity: 0 }}
                                                                    animate={{ y: 0, opacity: 1 }}
                                                                    exit={{ y: -5, opacity: 0 }}
                                                                    transition={{ duration: 0.15 }}>
                                                                    <td>
                                                                        <span>{font.filename}</span>
                                                                        <SampleText
                                                                            processFrom = "customFonts"
                                                                            editSampleText={
                                                                                editSampleText
                                                                            }
                                                                            fontFamily={
                                                                                font.filename
                                                                            }
                                                                            fontUrl={font.url}
                                                                            sampleText={sampleText}
                                                                            setEditSampleText={
                                                                                setEditSampleText
                                                                            }
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <button
                                                                            className="focus:outline-none outline-none"
                                                                            title='Copy Font Url'
                                                                            onClick={() =>
                                                                                handleFontLinkClick(
                                                                                    font.url
                                                                                )
                                                                            }
                                                                        >
                                                                            <LinkIcon />
                                                                        </button>
                                                                        <button
                                                                            className="focus:outline-none outline-none"
                                                                            title='Delete'
                                                                            onClick={() =>
                                                                                handleFontDelete(
                                                                                    font
                                                                                )
                                                                            }
                                                                        >
                                                                            <BsTrash size={16} />
                                                                        </button>
                                                                    </td>
                                                                </motion.tr>
                                                            )
                                                        )
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </motion.div>
                        )}
                    </div>
                </AnimatePresence>
            </div>
        </div>
    )
}

type SampelTextProps = {
    processFrom: string;
    editSampleText: boolean;
    setEditSampleText: (val: boolean) => void;
    fontFamily: string;
    sampleText: string;
    fontUrl: string;
}

const SampleText = (props: SampelTextProps) => {
    let { processFrom, setEditSampleText, fontFamily, sampleText, editSampleText } = props;
    let fontStyle, fontWeight;
    if (processFrom === "customFonts") {
        let updatedFont = handleCustomFontFace(fontFamily);
        fontFamily = updatedFont.fontName;
        fontStyle = updatedFont.fontStyle;
        fontWeight = updatedFont.fontWeight;
    }
    return (
        <span
            onDoubleClick={() => setEditSampleText(!editSampleText)}
            style={{ fontFamily: `${fontFamily}, sans-serif`, fontStyle: fontStyle ? fontStyle : "inherit", fontWeight: fontWeight ? fontWeight : 400 }}
            className="cursor-default select-none fonts-body__fonts-list-table__font-example"
        >
            {sampleText}
        </span>
    )
}
const Font = ({ id, url, name, setSelectedFontId, selectedFontId }: { id: string, url: string, name: string, setSelectedFontId: (arg: string) => void, selectedFontId?: string }) => {
    return (
        <div className={classNames("item", { selected: selectedFontId === id })} onClick={() => setSelectedFontId(id)}>
            <div className="font-wrapper">
                <FontIcon className='font' />
            </div>
            <div className="details-wrapper">
                <div title={name} className="filename">{name.substring(0, 15)}{name.length > 18 ? "..." : ""}</div>
                <div className="more-icon-wrapper">
                    <MoreElipsis />
                </div>
            </div>
        </div>
    )
}

type SearchFontsListProps = {
    displayedFonts: FontType[];
    dropdownIsOpen: boolean;
    shownFontsList: FontType[];
    handlePageClick: (selectedItem: { selected: number; }) => void;
    handleFontAddClick: (font: string) => void;
}

type Font = {
    id: string;
    filename: string;
    filetype: string;
    url: string;
    app_id: string;
    org_id: string;
    size: string | null;
    created_at: string;
    updated_at: string;
};

type FontInput = { [key: string]: Font };

type FontOutput = {
    googleFonts: { [key: string]: Font };
    customFonts: { [fontFamily: string]: { [key: string]: Font } };
};
interface UploadedFont {
    id: number;
    fileName: string;
    fileSize: string;
    fullName?: string | null;
    familyName?: string | null;
    subfamilyName?: string | null;
    status: "PENDING" | "LOADING" | "SUCCESS" | "ERROR";
    fileData: File;
    ext: string;
}

function getFontFamily(filename: string): string {
    const parts = filename.split('-');
    return parts.slice(0, -1).join('-'); // Remove subfamily and join remaining parts
}

function categorizeFonts(input: FontInput): FontOutput {
    const output: FontOutput = {
      googleFonts: {},
      customFonts: {},
    };
  
    for (const key in input) {
      const font = input[key];
  
      if (font.url.includes('fonts.googleapis.com')) {
        output.googleFonts[key] = font;
      } else {
        const fontFamily = getFontFamily(font.filename);
  
        if (!output.customFonts[fontFamily]) {
          output.customFonts[fontFamily] = {};
        }
  
        output.customFonts[fontFamily][key] = font;
      }
    }
  
    return output;
}

const FontsSearchList = (props: SearchFontsListProps) => {
    const { displayedFonts, dropdownIsOpen, shownFontsList, handlePageClick, handleFontAddClick } = props;
    const googleFontsList: { [key: string]: any } = useSelector((state: RootState) => state.staticAssets.fonts)
    const [mouseHoverIndex, setMouseHoverIndex] = useState(-1)

    const pageCount = Math.ceil(shownFontsList?.length / itemsPerPage);

    useEffect(() => {
        loadRequiredGoogleFonts(displayedFonts)
    }, [displayedFonts])

    const handleMouseEnter = (index: number) => {
        setMouseHoverIndex(index)
    }

    const handleMouseLeave = () => {
        setMouseHoverIndex(-1)
    }

    return (
        <div className='fonts-search-results'>
            {displayedFonts?.length > 0 && dropdownIsOpen && <div className='fonts-search-results__dropdown'>
                {displayedFonts.map((font: any, index: number) => {
                    const isFontImported = Object.values(googleFontsList).findIndex(importedFont => importedFont.filename === font.filename) !== -1;
                    return (
                        <div className="flex h-20 items-center p-2 hover:bg-gray-100 justify-between" onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={handleMouseLeave} key={index}>
                            <div className="font-name__wrapper text-lg">
                                <p className="font-name mb-0">
                                    {font.filename}
                                </p>
                                <p className="font-sample-text text-md mb-0" style={{ fontFamily: `${font.filename}` }}>
                                    {DEFAULT_FONT_TEXT}
                                </p>
                            </div>
                            <div className={`font-icons__container items-center justify-center w-10 h-10 ${mouseHoverIndex === index ? "flex" : "hidden"} ${!isFontImported ? "cursor-pointer" : ""}`}
                                onClick={() => {
                                    if (!isFontImported) {
                                        handleFontAddClick(font.filename)
                                    }
                                }}
                            >
                                {isFontImported ? <TickIcon /> :
                                    <DownloadIcon />}
                            </div>
                        </div>
                    )
                })}
                <ReactPaginate
                    previousLabel={<MdChevronLeft size={20} className='leftIcon' />}
                    nextLabel={<MdChevronRight size={20} className='rightIcon' />}
                    breakLabel={'...'}
                    pageCount={pageCount}
                    marginPagesDisplayed={0}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={'pagination'}
                    activeClassName={'active'}
                />
            </div>}
        </div>
    )
}

export const CustomFontUploadModal = (props: any) => {
    const maxFileCount = 8;
    const { SuccessToast, ErrorToast } = useToast();
    const [uploadedFonts, setUploadedFonts] = useState<UploadedFont[]>([]);
    let { isVisible, handleCustomVisible, handleFontUpload } = props;
    const [hovered, setHovered] = useState<number | null>(null);
    let [buttonDisable, setButtonDisable] = useState<boolean>(false)

    const loadFontDetails = async (file: File, id: number) => {
       
        const arrayBuffer = await file.arrayBuffer();
        const loadedFont = fontkit.create(new Uint8Array(arrayBuffer));
        const newFont: UploadedFont = {
            id,
            fileName: file.name,
            fileSize: (file.size / (1024 * 1024)).toFixed(2) + " MB",
            fullName: loadedFont.fullName,
            familyName: loadedFont.familyName,
            subfamilyName: loadedFont.subfamilyName,
            status: "PENDING",
            fileData: file,
            ext: "ext"
        };

        setUploadedFonts((prevFonts) => [...prevFonts, newFont]);
    };

    function validateFiles(files: File[]): { isValid: boolean; message: string } {
        const allowedExtensions = ["ttf", "otf", "woff", "woff2"];
        const maxTotalSizeMB = 10;
        let totalSize = 0;
    
        if (files.length > maxFileCount || uploadedFonts.length  + files.length > maxFileCount) {
            return { isValid: false, message: `You can upload up to ${maxFileCount} files only.` };
        }
    
        for (const file of files) {
            const fileExtension = file.name.split(".").pop()?.toLowerCase();
            if (!allowedExtensions.includes(fileExtension || "")) {
                return { isValid: false, message: `Invalid file type: ${file.name}. Only .ttf, .otf, .woff, and .woff2 are allowed.` };
            }
    
            totalSize += file.size;
        }
    
        if (totalSize / (1024 * 1024) > maxTotalSizeMB) {
            return { isValid: false, message: `Total file size exceeds ${maxTotalSizeMB} MB.` };
        }
    
        return { isValid: true, message: "Files are valid for upload." };
    }


    const onDrop = useCallback((acceptedFiles: File[]) => {
        const validation = validateFiles(acceptedFiles);

    if (!validation.isValid) {
        ErrorToast(validation.message);
        return;
    }

        acceptedFiles.forEach((file, index) => {
            loadFontDetails(file, uploadedFonts.length + index);
        });
    }, [uploadedFonts]);

    const deleteFont = (id: string | number) => {
        setUploadedFonts((prevFonts) => prevFonts.filter((font) => font.id !== id));
    };

    const handleUploader = async () => {
        for (let i = 0; i < uploadedFonts.length; i++) {
            const font = uploadedFonts[i];
            
            font.status = "LOADING";
            setUploadedFonts([...uploadedFonts]);
            setButtonDisable(true)
            try {
                await handleFontUpload(font);
                font.status = "SUCCESS";
                setUploadedFonts([...uploadedFonts]);
            } catch (error: any) {
                font.status = "ERROR";
                if (error.response) {
                    ErrorToast(`Error: ${error.response.data.message || 'Something went wrong'}`);
                } else {
                    ErrorToast(`Error: ${error.message}`);
                }
            }
        }
        setButtonDisable(false)
        handleCustomVisible(false);
        setUploadedFonts([]);
    };
    

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        multiple: true,
        accept: {
            "font/ttf": [".ttf"],
            "font/otf": [".otf"],
            "font/woff": [".woff"],
            "font/woff2": [".woff2"],
        },
        disabled: uploadedFonts.length >= 8,
    });
    return (
        isVisible && (
            <>
                <div className="custom-font-backdrop-overlay" />
                <AnimatePresence>
                    <motion.div
                        initial= {{ opacity: 0, scale: 0.75 }}
                        animate= {{
                            opacity: 1,
                            scale: 1,
                            y: 0,
                            transition: { ease: "easeOut", duration: 0.15 },
                        }}
                        exit= {{
                            opacity: 0,
                            scale: 0.75,
                            transition: { ease: "easeIn", duration: 0.15 },
                        }}
                        className= "custom-font-modal-container"
                    >
                        <div className="custom-font-modal-content relative">
                            <div className="flex flex-col items-center h-full">
                                <h3 className="custom-font-modal-title">Upload Custom Typeface</h3>
                                <p className="custom-font-modal-subtitle">
                                    Add custom font files to use in your app.
                                </p>
                                <div
                                    {...getRootProps()}
                                    className={`custom-font-dropzone ${isDragActive ? "active" : ""}`}
                                >
                                    <input {...getInputProps()} accept=".ttf, .otf, .woff, woff2" />
                                    <UploadCustomFont/>
                                    <p className="custom-font-modal-subtitle" style={{color: "#000000", marginBottom: "6px", marginTop: "14px"}}>
                                        Drop your font files (.ttf, .otf, .woff, or .woff2) here.
                                    </p>
                                    {isDragActive ? (
                                        <p>Drop the files here...</p>
                                    ) : (
                                        <>
                                            <p className="custom-font-modal-desc">
                                                Note: For optimal browser compatibility,use only TTF, OTF, WOFF, and WOFF2 file formats. You can upload up to {maxFileCount} files at once.
                                            </p>
                                            <button className="custom-font-select-btn" style={{cursor: uploadedFonts.length >= 8 ? "not-allowed" : "pointer"}}>Select Files</button>
                                        </>
                                    )}
                                </div>
                                <div className="w-full" style={{ padding: "0px 10px", overflowY: "auto" }}>
                                    {uploadedFonts.map((rowItem) => {
                                        const fileNameParts = rowItem.fileName.split(".");
                                        const fileExtension = fileNameParts[fileNameParts.length - 1];
                                        return (
                                        <div
                                            className="flex items-center justify-between"
                                            style={{ marginBottom: "12px" }}
                                            key={"fileList" + rowItem.id}
                                            onMouseEnter={()=>{
                                                setHovered(rowItem.id)
                                            }}
                                            onMouseLeave={()=>{
                                                setHovered(null)
                                            }}
                                        >
                                            <p
                                                className="flex items-center"
                                                style={{ color: "#000000", margin: 0, transition: "all 0.3s ease-in-out"}}
                                            >
                                                {rowItem.status === "ERROR" && (
                                                    <span
                                                    style={{
                                                        background: "none",
                                                        border: "none",
                                                        margin: 0,
                                                        padding:0,
                                                        paddingRight: "8px",
                                                        height: "14px"
                                                    }}>
                                                        <FontError/>
                                                    </span>
                                                )}
                                                <span style={{whiteSpace:"nowrap", textOverflow: "ellipsis", overflow: "hidden", maxWidth: "200px" }}>{rowItem.familyName} - {rowItem.subfamilyName}</span>{" "}
                                                <span style={{ color: "#6a6a6a", paddingLeft: "10px" }}>{rowItem.fileSize}</span>
                                            </p>
                                            <div className="flex justify-center items-center" style={{ margin: 0 }}>
                                                {fileExtension.toUpperCase()}
                                                <div className="flex justify-center items-center" style={{ minWidth: "18px", height: "18px", marginLeft: "16px",paddingBottom: "8px" }}>
                                                    {hovered === rowItem.id && rowItem.status === "PENDING" && (
                                                        <motion.button
                                                            style={{
                                                                cursor: "pointer",
                                                                background: "none",
                                                                border: "none",
                                                                margin: 0,
                                                                padding: 0,
                                                                transform: "translateY(3px)",
                                                                height: "14px",
                                                            }}
                                                            className= "focus:outline-none outline-none"
                                                            initial= {{ opacity: 0, scale: 0.9 }}
                                                            animate= {{ opacity: 1, scale: 1 }}
                                                            exit= {{ opacity: 0, scale: 0.9 }}
                                                            transition= {{ duration: 0.3 }}
                                                            onClick= {() => deleteFont(rowItem.id)}
                                                        >
                                                            <FontDelete />
                                                        </motion.button>
                                                    )}
                                                    {rowItem.status === "LOADING" && (
                                                    <motion.span
                                                        style={{
                                                        background: "none",
                                                        border: "none",
                                                        margin: 0,
                                                        padding: 0,
                                                        height: "14px",
                                                        }}
                                                        initial={{ opacity: 0, scale: 0.9 }}
                                                        animate={{ opacity: 1, scale: 1 }}
                                                        exit={{ opacity: 0, scale: 0.9 }}
                                                        transition={{ duration: 0.3 }}
                                                    >
                                                        <AiOutlineLoading3Quarters
                                                        size={14}
                                                        style={{
                                                            animation: "spin 1s linear infinite",
                                                        }}
                                                        />
                                                    </motion.span>
                                                    )}
                                                    {rowItem.status === "SUCCESS" && (
                                                    <motion.span
                                                        style={{
                                                        background: "none",
                                                        border: "none",
                                                        margin: 0,
                                                        padding: 0,
                                                        height: "14px",
                                                        }}
                                                        initial={{ opacity: 0, scale: 0.9 }}
                                                        animate={{ opacity: 1, scale: 1 }}
                                                        exit={{ opacity: 0, scale: 0.9 }}
                                                        transition={{ duration: 0.3 }}
                                                    >
                                                        <FontSuccess />
                                                    </motion.span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="custom-font-modal-footer">
                                <button
                                    className= "custom-font-cancel-btn"
                                    disabled= {buttonDisable}
                                    onClick= {() => {
                                        handleCustomVisible(false);
                                        setUploadedFonts([])
                                    }}
                                >
                                    CANCEL
                                </button>
                                <button 
                                    className= "custom-font-upload-btn" 
                                    disabled= {buttonDisable} 
                                    onClick= {handleUploader}>
                                    UPLOAD
                                </button>
                            </div>
                        </div>
                    </motion.div>
                </AnimatePresence>
            </>
        )
    );
}